<template>
  <div class="molecule-list-alert_container">
    <div
      v-for="(alert, index) in alertData"
      :key="index"
      class="molecule-list-alert_card"
      :class="[alert.isEnabled ? 'card--enabled' : 'card--disabled']"
      @click="clickAlert(alert)"
    >
      <div class="card__detail">
        <div class="detail__header">
          <div class="header__title">
            <div class="header__top">
              <label
                :class="[
                  alert.isEnabled ? 'title--name' : 'title--name_disabled',
                ]"
              >
                <span v-if="alert.alertName">{{ alert.alertName }}</span>
                <span v-else>-</span>
              </label>
              <div v-if="canUpdate" @click.stop="onClickSwitchEnabled(index)">
                <atom-switch
                  v-model="alert.isEnabled"
                  class="header__switch"
                ></atom-switch>
              </div>
            </div>
            <label
              :class="[
                alert.isEnabled
                  ? 'title--description'
                  : 'title--description_disabled',
              ]"
            >
              <span v-if="alert.alertDescription">{{
                alert.alertDescription
              }}</span>
              <span v-else>-</span>
            </label>
          </div>
          <div v-if="alert.isAlertThresholdEnable" class="header__info">
            <div class="info__count">
              <span class="count__topic text--topic">MAXIMUM ALERT COUNT</span>
              <label
                :class="[
                  alert.isEnabled ? 'count--number' : 'count--number_disabled',
                ]"
              >
                <span v-if="alert.alertCount">{{ alert.alertCount }}</span>
                <span v-else>-</span>
              </label>
            </div>
            <div class="info__interval">
              <span class="interval__topic text--topic"
                >THRESHOLD INTERVAL (MINUTE)</span
              >
              <label
                :class="[
                  alert.isEnabled
                    ? 'interval--number'
                    : 'interval--number_disabled',
                ]"
              >
                <span v-if="alert.alertInterval">{{
                  alert.alertInterval
                }}</span>
                <span v-else>-</span>
              </label>
            </div>
          </div>
        </div>
        <div class="detail__content">
          <div class="content__email">
            <label class="text--topic">EMAIL</label>
            <div v-for="(email, index) in alert.email" :key="index">
              <label
                :class="[
                  alert.isEnabled ? 'text--body' : 'text--body_disabled',
                ]"
              >
                <span v-if="email.alertEmailAddress">{{
                  email.alertEmailAddress
                }}</span>
                <span v-else>-</span>
              </label>
            </div>
            <div v-if="!alert.email.length">
              <label
                :class="[
                  alert.isEnabled ? 'text--body' : 'text--body_disabled',
                ]"
                >-</label
              >
            </div>
          </div>
          <div class="content__sms">
            <label class="text--topic">SMS</label>
            <div v-for="(sms, index) in alert.sms" :key="index">
              <label
                :class="[
                  alert.isEnabled ? 'text--body' : 'text--body_disabled',
                ]"
              >
                <span v-if="sms.alertSmsNumber">{{ sms.alertSmsNumber }}</span>
                <span v-else>-</span>
              </label>
            </div>
            <div v-if="!alert.sms.length">
              <label
                :class="[
                  alert.isEnabled ? 'text--body' : 'text--body_disabled',
                ]"
                >-</label
              >
            </div>
          </div>
          <div class="content__line">
            <label class="text--topic">LINE NOTIFICATION</label>
            <div v-for="(line, index) in alert.line" :key="index">
              <div
                :class="[
                  alert.isEnabled ? 'text--body' : 'text--body_disabled',
                ]"
              >
                <span v-if="line.alertLineTokenName">{{
                  line.alertLineTokenName
                }}</span>
                <span v-else>-</span>
              </div>
            </div>
            <div v-if="!alert.line.length">
              <label
                :class="[
                  alert.isEnabled ? 'text--body' : 'text--body_disabled',
                ]"
                >-</label
              >
            </div>
          </div>
          <div class="content__path">
            <label class="text--topic">ALERT SMS GATEWAY PATH</label>
            <div>
              <div
                :class="[
                  alert.isEnabled ? 'text--body' : 'text--body_disabled',
                ]"
              >
                <span v-if="alert.path">{{ alert.path }}</span>
                <span v-else>-</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card__enabled">
        <div v-if="canUpdate" @click.stop="onClickSwitchEnabled(index)">
          <atom-switch
            v-model="alert.isEnabled"
            class="enabled__switch"
          ></atom-switch>
        </div>

        <div class="enabled__monitor">
          <span class="monitor--title">Monitor</span>
          <span
            :class="[
              alert.isEnabled ? 'monitor--number' : 'monitor--number_disabled',
            ]"
            >{{ alert.monitorCount }} servers</span
          >
        </div>
      </div>
    </div>
    <molecule-modal-dialog
      v-if="alertData.length !== 0"
      modalId="modal-confirm-enable-alert"
      :isTextCenter="true"
      :textTitle="`Do you want to ${
        !alertData[index].isEnabled ? 'Enable' : 'Disable'
      } Monitoring\nfor ${alertData[index].alertName}?`"
      buttonTextLeft="Confirm"
      @clickButtonLeft="clickConfirmIsEnabled(alertData[index].id)"
    ></molecule-modal-dialog>
  </div>
</template>

<script>
import AtomSwitch from "@/components/atoms/AtomSwitch.vue"
import MoleculeModalDialog from "@/components/molecules/MoleculeModalDialog.vue"
import Vue from "vue"
export default {
  name: "MoleculeListAlert",
  components: { AtomSwitch, MoleculeModalDialog },
  props: {
    alertData: {
      type: Array,
      required: true,
    },
    canUpdate: {
      type: Boolean,
      required: true,
    },
  },
  emits: ["onClickSwitchEnabled", "selectedCard"],
  data() {
    return {
      index: 0,
    }
  },
  methods: {
    // click switch alert
    onClickSwitchEnabled(index) {
      this.index = index
      // use nexttick
      Vue.nextTick(() => {
        this.alertData[index].isEnabled = !this.alertData[index].isEnabled
      })
      this.modalId = "modal-confirm-enable-alert"
      this.$bvModal.show(this.modalId)
    },

    // confirm enable modal
    clickConfirmIsEnabled(id) {
      this.closeModal()
      this.$emit("onClickSwitchEnabled", id)
    },

    // select alert
    clickAlert(alert) {
      this.$emit("selectedCard", alert)
    },

    // close modal
    closeModal() {
      this.$bvModal.hide(this.modalId)
      this.modalId = ""
    },
  },
}
</script>

<style lang="scss" scoped>
.text--topic {
  color: #b9b9c3;
  font-weight: 500;
  font-size: 12px;
}
.text--body,
.text--body_disabled {
  font-weight: 600;
  font-size: 12px;
  width: 100%;
  max-width: 247px;
  padding: 1px 9px 1px 9px;
  border-radius: 4px;
  margin-bottom: 5px;
}

.text--body {
  color: #7367f0;
  background: #eeedfd;
}
.text--body_disabled {
  color: #b9b9c3;
  background: #f1f2f2;
}

.molecule-list-alert_card {
  box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.06);
  border-radius: 6px;
  padding: 0 21px 0 32px;
  margin-bottom: 16px;

  &:hover {
    cursor: pointer;
  }
}
.card--enabled {
  background: #ffffff;
}
.card--disabled {
  background: #fcfcfc;
}

// card left
.card__detail {
  width: 100%;
  border-bottom: 1px solid #ebe9f1;
}
.detail__header {
  padding: 14px 0 0 0;
  width: 100%;
}
.header__top {
  display: flex;
  width: 100%;
  justify-content: space-between;
}
.header__title {
  display: flex;
  flex-direction: column;
}
.header__switch {
  display: block;
}
.title--name,
.title--name_disabled {
  font-weight: 600;
  font-size: 18px;
  max-width: calc(100% - 50px);
  padding-right: 10px;
}
.title--name {
  color: #5e5873;
}
.title--name_disabled {
  color: rgba(94, 88, 115, 0.75);
}
.title--description,
.title--description_disabled {
  font-weight: 400;
  font-size: 12px;
  max-width: 100%;
  padding-right: 10px;
}
.title--description {
  color: #5e5873;
}
.title--description_disabled {
  color: rgba(94, 88, 115, 0.75);
}
.header__info {
  margin-top: 16px;
}
.info__count,
.info__interval {
  margin-bottom: 10px;
  height: 43px;
  border-left: 4px solid #d8d6de;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.count__topic,
.interval__topic {
  margin-left: 19px;
}
.count--number,
.interval--number,
.count--number_disabled,
.interval--number_disabled {
  margin-right: 19px;
  font-weight: 500;
  font-size: 21px;
  margin-left: 19px;
}

.count--number,
.interval--number {
  color: #5e5873;
}

.count--number_disabled,
.interval--number_disabled {
  color: rgba(94, 88, 115, 0.75);
}

.detail__content {
  padding: 24px 0 20px 0;
}
.content__email,
.content__sms,
.content__line {
  min-width: 15%;
  margin-bottom: 15px;
}

// card right
.card__enabled {
  padding: 14px 0 25px 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-end;
}
.enabled__switch {
  display: none;
}
.enabled__monitor {
  background: #f8f8f8;
  width: 100%;
  height: 53px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.monitor--title {
  color: #b9b9c3;
  font-size: 14px;
  font-weight: 400;
}
.monitor--number,
.monitor--number_disabled {
  font-weight: 500;
  font-size: 14px;
}
.monitor--number {
  color: #5e5873;
}
.monitor--number_disabled {
  color: rgba(94, 88, 115, 0.75);
}

// Small devices (landscape phones, 576px and up)
@media screen and (min-width: 576px) {
  .molecule-list-alert_card {
    display: flex;
  }

  // card left
  .card__detail {
    width: calc(100% - 154px);
    padding-right: 15px;
    border-bottom: 0;
    border-right: 1px solid #ebe9f1;
  }

  .header__title {
    display: flex;
    flex-direction: column;
  }
  .header__switch {
    display: none !important;
  }
  .title--name,
  .title--name_disabled {
    max-width: 100%;
  }

  .detail__content {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }
  .content__email,
  .content__sms,
  .content__line {
    margin-right: 10px;
    margin-bottom: 0;
  }

  // card right
  .card__enabled {
    width: 154px;
  }
  .enabled__switch {
    display: block;
  }
  .enabled__monitor {
    margin-top: 27px;
    width: 114px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
}

// Medium devices (tablets, 768px and up)
@media screen and (min-width: 768px) {
}

// Large devices (desktops, 992px and up)
@media screen and (min-width: 992px) {
  .molecule-list-alert_container {
    padding: 20px 25px 10px;
    height: calc(100vh - 300px);
    overflow-y: auto;
  }
  .organism-alert-management_content {
    margin-top: 20px;
  }

  .title--name,
  .title--name_disabled {
    max-width: 300px;
    padding-right: 0;
  }
  .title--description,
  .title--description_disabled {
    max-width: 300px;
    padding-right: 0;
  }
  .detail__header {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }
  .header__info {
    margin-top: 0;
    margin-right: 16px;
    display: flex;
  }
  .info__count,
  .info__interval {
    margin-left: 17px;
    border-left: none;
    border-right: 4px solid #d8d6de;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
  }
  .count__topic,
  .interval__topic {
    margin-left: 0;
    margin-right: 19px;
  }
  .count--number,
  .interval--number,
  .count--number_disabled,
  .interval--number_disabled {
    margin-left: 0;
    margin-right: 19px;
  }
}

// X-Large devices (large desktops, 1200px and up)
@media screen and (min-width: 1200px) {
}
</style>
